<template>
   <BaseLayout> 
    <!-- 主内容 -->
    <div> 
      
      <TitleModel
            :title="'商务舱CITY'"
            :content="'  '" /> 

      <!-- princess -->
      <div class="wp-relative">   
        <div class="dt-css-grid"> 
          
          <div class="wf-cell" v-for="aitem in contactList" :key="aitem.id">
            <article>
              <div class="wf-cell-img" >
                <a class="wf-cell-link" @click="alinkFun(aitem.id)">
                  <el-image
                  style="width: 100%; height: 320px"
                  :src="baseURL+aitem.urlimage"
                  :fit="fit" 
                  ></el-image>
                </a> 
              </div>

              <div class="wf-cell-desc">
                <h3> <a  @click="alinkFun(aitem.id)" target  :title="'img11 --'" rel="bookmark">{{ aitem.title }}</a></h3>
                <div>
                  <p>{{aitem.desc }}</p>
                </div>
              </div>   
            </article> 
          </div> 
        </div>  
          
      </div>        
        
       
      <TitleModel
            :title="'联系方式'"
            content="欢迎通过以下方式联系我们，365天全年无休。" 
            content2="温柔贴心女客服（小爱/红豆）竭诚为您服务。"
            content3="我们的营业时间是11Am-2Am，如需预约此时段外，请提前联系。"/> 
      <!-- contact -->
      <CommContact />
      <!-- <div class="wp-relative">
        <div class="dt-contact-grid">
          <IcoListModel :title="'半小时起约经济舱'" :ListInfo="contactList"/>
          
          <IcoListModel :title="'长按添加Line'" :QRCode="QRCode"/>
        </div>
      </div> -->

    
      <!-- <div class="wp-relative"> 
        <IcoListModel :title="'应聘及商务合作请联系：'" :ListInfo="contactList2"/>
      </div>
      
      <div class="wp-relative">
        <p class="real-time">本公司MM为预约制，每天即时更新网站，您在本页浏览到的皆为在线可约，点击封面照片查看全部靓照及资料。为避免错过心仪的她，强烈建议您订阅或收藏本站odaus.com</p>
      </div>

      <div class="wp-relative"> 
        <IcoListModel :title="'Tao家，美洲No.1伴君品牌，8年口碑值得信赖，万千狼友的最佳选择。做服务，我们是认真的！'" />
      </div>  -->
    </div>
     
  </BaseLayout>

</template>



<script>
import {mapState,mapMutations} from 'vuex';
// import { Plus } from '@element-plus/icons-vue'; //Plus,
import BaseLayout from '@/components/BaseLayout.vue';
// import MyTeleport from '@/components/MyTeleport'; MyTeleport
import TitleModel from '@/components/TitleModel.vue';
// import IcoListModel from '@/components/IcoListModel.vue';
import CommContact from '@/components/CommContact.vue';
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: { 
    BaseLayout, 
    TitleModel, 
    CommContact
  },
  data() {
    return {
      showModal: false,
      fit:'cover',
      hoveredIndex : null,
      baseURL:this.$store.state.apiUrl,//'https://api2.seattletaotao.com',
      getUrl:'/api/princess/getList' 
    };
  } ,
  computed: {
    ...mapState(['contactList','princessIndex']) 
  },
  methods: {
    ...mapMutations(['setPrincessIndex']),
    alinkFun(pid) {
      this.$local.setItem('pid',pid);
      this.setPrincessIndex(pid);
      this.$router.push({ path: '/product'}); //, params: { pid: pid}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url(@/assets/css/commPage.scss);

.wf-cell-desc{
  z-index: 10;
  padding: 15px 10px 10px 10px !important;
  
  h3{
    font-size: 22px !important;
    color: #F3E69E !important;
    margin-top: 0;
    margin-bottom: 5px;
    text-transform: none;
    clear: none;
    a{
      color: #fbedcd;
      display: inline-block;
      -webkit-transition: none;
      transition: none;
    }
  }
  div{
    font-weight: 1000;
    background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent;
  }

}
   
.wf-cell-link{
  position: relative;
  display: block;
  line-height: 0;
  overflow: hidden;  
  height: 100%;
  width: 100%;
}
.wf-cell-link .el-image:hover{ 
    transform: scale(1.3);
    transition: transform 0.6s ease;
    -webkit-transition: -webkit-transform .6s ease-out, opacity .6s;
    transition: transform .6s ease-out, opacity .6s;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden; 
} 

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
